import { useEffect, useState } from "react";
import { OrderDetails } from "@/types";
import { OrderOuttakes } from "@/components/pages";
import { useApi } from "@/api";
import { useParams } from "react-router-dom";

const OrderOuttakesView = () => {
      const { order } = useParams<'order'>();
      const {order: orderEntity } = useApi();
      const [fetched, setFetched] = useState(false);
      const [details, setDetails] = useState<OrderDetails>();
      
    
      const getOrderDetails = async (value: string) => {
        await orderEntity.getDetailedOrderData(value);
      }      

    useEffect(() => {
        if (order && !fetched) {
        getOrderDetails(order);
        setFetched(true);
        }
    }, [order, orderEntity.orderDetails]);

    useEffect(() => {
        const { orderDetails } = orderEntity;
    
        if (orderDetails) {
          setDetails(orderDetails);
        }
      }, [order, orderEntity.orderDetails]);

      return (<>
      { details && <OrderOuttakes
        orderDetails={details}
      />}
      </>);
}

export default OrderOuttakesView;